// extracted by mini-css-extract-plugin
module.exports = {"focus":"Checkbox_focus__QsnBf","label":"Checkbox_label__Tg93i","icon":"Checkbox_icon___mPXi","notSelected":"Checkbox_notSelected__unio0","selected":"Checkbox_selected__oePo1"};